module.exports = __webpack_public_path__ + "static/colors-content-hierarchy-dont-e1fdb51b908451bd37b6e06d09ba790f.png";